import axios from 'axios';

const markAiDisclaimerViewed = async () => {
  axios.put(
    '/admin/ui_states',
    { ui_state: { attribute: 'viewed_ai_tools_consent_information', value: true } },
    {
      responseType: 'json',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content'),
      },
    },
  );
};

export default markAiDisclaimerViewed;
